import { Component } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { AccountService } from '../account.service';
import { FirebaseService } from 'app/services/firebase.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'reset-password',
  templateUrl: './resetPassword.component.html',
  styleUrls: [
    '../account.scss',
    '../container/container.component.scss',
    './resetPassword.component.scss',
  ],
})
export class ResetPasswordComponent {
  public user = {
    email: '',
  };

  errors = {
    email: '',
  };

  public isEmailFound;
  public isLoading;

  constructor(
    private translate: TranslateService,
    private accountService: AccountService,
    private toasterService: ToasterService,
    private firebaseService: FirebaseService
  ) {}

  public onSubmit() {
    this.isLoading = true;
    this.accountService.reset(this.user).subscribe(
      response => {
        this.isEmailFound = true;
        this.firebaseService.logEvent('login_password_forget', {});
      },
      response => {
        const err = response.error;
        this.isLoading = false;
        if (response.status === 404) {
          this.translate
          .get('unknown_email')
          .subscribe((res: string) => {
            err.email = res;
          });
          this.errors.email = err.email;
        } else {
          this.toasterService.pop('error', undefined, err.email);
          this.user['errors'] = err;
        }

      }
    );
  }
}
